// extracted by mini-css-extract-plugin
export var backButton = "backbutton-module--backButton--cU05_";
export var label = "backbutton-module--label--11_f7";
export var icon = "backbutton-module--icon--3YPEc";